import React from "react";
import { useTheme } from "../hooks/use-theme";
import Text from "../components/Text";

type EmptyListInfoProps = {
    text: string;
};

const EmptyListInfo: React.FC<EmptyListInfoProps> = ({ text }: EmptyListInfoProps) => {
    const { fonts, colors } = useTheme();

    return (
        <Text style={{ ...fonts.bodyMedium, textAlign: "center", color: colors.onSurfaceDisabled }}>
            {text}
        </Text>
    );
};

export default EmptyListInfo;
